import { render, staticRenderFns } from "./OnsiteSearchProductResultItem.vue?vue&type=template&id=6117ad64&"
import script from "./OnsiteSearchProductResultItem.vue?vue&type=script&lang=ts&"
export * from "./OnsiteSearchProductResultItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports